import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { isDevelopmentReactStrictMode } from './config/envConfig';
import loggerService from './services/LoggerService';

import { initCapacitor } from './capacitor';

// Auto-reload on ChunkLoadError (stale deployment: old index.html references chunk files that no longer exist)
// 'Sd' is the minified name of ChunkLoadError in production builds
const isChunkLoadError = (error: any): boolean =>
  error?.name === 'ChunkLoadError' || error?.name === 'Sd';

window.addEventListener('error', (event) => {
  if (!isChunkLoadError(event?.error)) return;
  const reloadedKey = 'chunk_reload_attempted';
  if (!sessionStorage.getItem(reloadedKey)) {
    sessionStorage.setItem(reloadedKey, '1');
    window.location.reload();
  } else {
    loggerService.error(event?.error);
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (!isChunkLoadError(event?.reason)) return;
  event.preventDefault(); // prevent Sentry from also capturing this — we handle it below
  const reloadedKey = 'chunk_reload_attempted';
  if (!sessionStorage.getItem(reloadedKey)) {
    sessionStorage.setItem(reloadedKey, '1');
    window.location.reload();
  } else {
    loggerService.error(event?.reason);
  }
});

// Check localStorage availability at startup
try {
  const testKey = '__storage_test__';
  localStorage.setItem(testKey, '1');
  localStorage.removeItem(testKey);
} catch {
  loggerService.error(
    'localStorage is not available on this device/browser'
  );
}

const container = document.getElementById('root');
const root = ReactDOM.createRoot(container!);

root.render(
  isDevelopmentReactStrictMode ? (
    <React.StrictMode>
      <App />
    </React.StrictMode>
  ) : (
    <App />
  )
);

serviceWorkerRegistration.register();
reportWebVitals();

// Initialize Capacitor native plugins (no-op on web)
initCapacitor();